import script from "./DevGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./DevGuide.vue?vue&type=script&setup=true&lang=js"

import "./DevGuide.vue?vue&type=style&index=0&id=8895d712&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8895d712"]])

export default __exports__